import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Card from '../../components/Card'
import Input from '../../components/Input'
import Row from '../../components/Row'
import Text from '../../components/Text'
import patient from '../../stores/patient'

const EyeLabel = styled.div`
  text-align: center;
  font-weight: 300;
  align-self: center;
`

@observer
export default class IndexesForm extends Component {
  render() {
    return (
      <Card>
        <Card.Pad>
          <Row>
            <Row.Cell style={{ alignSelf: 'center' }}>
              <EyeLabel><Text str="titles.rightEye" /></EyeLabel>
            </Row.Cell>
            <Row.Cell>
              <Input
                label="titles.recent"
                name="rightRecentVFI"
                value={patient.fields.rightRecentVFI}
                onChange={patient.setVFI}
              />
            </Row.Cell>
            <Row.Cell>
              <Input
                label="titles.previous"
                name="rightPreviousVFI"
                value={patient.fields.rightPreviousVFI}
                onChange={patient.setVFI}
              />
            </Row.Cell>
            <Row.Cell>
              <Input
                label="titles.baseline"
                name="rightBaselineVFI"
                value={patient.fields.rightBaselineVFI}
                onChange={patient.setVFI}
              />
            </Row.Cell>
          </Row>
        </Card.Pad>
        <Card.Divider />
        <Card.Pad>
          <Row>
            <Row.Cell style={{ alignSelf: 'center' }}>
              <EyeLabel><Text str="titles.leftEye" /></EyeLabel>
            </Row.Cell>
            <Row.Cell>
              <Input
                label="titles.recent"
                name="leftRecentVFI"
                value={patient.fields.leftRecentVFI}
                onChange={patient.setVFI}
              />
            </Row.Cell>
            <Row.Cell>
              <Input
                label="titles.previous"
                name="leftPreviousVFI"
                value={patient.fields.leftPreviousVFI}
                onChange={patient.setVFI}
              />
            </Row.Cell>
            <Row.Cell>
              <Input
                label="titles.baseline"
                name="leftBaselineVFI"
                value={patient.fields.leftBaselineVFI}
                onChange={patient.setVFI}
              />
            </Row.Cell>
          </Row>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPatient/IndexesForm.js